var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAutomations = function SvgAutomations(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9996 10.0001H10.0079M12.9459 12.9464C9.04063 16.8516 4.55571 18.6984 2.92853 17.0712C1.30134 15.444 3.14807 10.9591 7.05332 7.05384C10.9586 3.1486 15.4435 1.30187 17.0707 2.92905C18.6978 4.55624 16.8511 9.04115 12.9459 12.9464ZM12.9458 7.05369C16.8511 10.9589 18.6978 15.4439 17.0706 17.071C15.4434 18.6982 10.9585 16.8515 7.05328 12.9462C3.14804 9.041 1.30131 4.55609 2.92849 2.9289C4.55568 1.30172 9.0406 3.14845 12.9458 7.05369ZM10.4163 10.0001C10.4163 10.2302 10.2297 10.4168 9.9996 10.4168C9.76948 10.4168 9.58293 10.2302 9.58293 10.0001C9.58293 9.77 9.76948 9.58345 9.9996 9.58345C10.2297 9.58345 10.4163 9.77 10.4163 10.0001Z",
    stroke: "#C7CDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAutomations);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "automations.4d3fa0cf23daa6419ab25fe9e9272223.svg";